import React, { Fragment } from 'react'
import HeroSection from './HeroSection'
import HowItWorks from './HowItWorks'
import OurMission from './OurMission'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import useApp from 'utils/hooks/useApp'
import Subscriptions from './DwSubscriptions'
import OurProducts from './OurProducts'
 import ParentRef from '../parentRef/ParentRef'

function HomeScreen() {
    const { t } = useTranslation()
    const { app } = useApp()

    return (
        <Fragment>
            {/* ________________________  SEO FOR HOMEPAGE  ______________________ */}
            <Helmet>
                <title>{t('home:seo.title')}</title>
                <meta
                    name="description"
                    content={t('home:seo.meta.description')}
                />
                <meta name="keywords" content={t('home:seo.meta.keywords')} />
                {/* Add more meta tags as needed for SEO */}
            </Helmet>

            {/* _______________________  COMPONENTS  _____________________________ */}



            <HeroSection />
            <HowItWorks />
            <OurMission />
            {/* DEFAULT DWSUBSCRIPTIONS */}
            <Subscriptions />
            <OurProducts />

            {/* ACTUAL PUBLISHER SUBSCRIPTIONS */}
            {/* {app.currentUser ? <Subscriptions /> : null} */}
            {/* <WhatToExpect /> */}
        </Fragment>
    )
}

export default HomeScreen
